import { render, staticRenderFns } from "./ClassroomDetailTeacherAddNew.vue?vue&type=template&id=5fe14034&scoped=true"
import script from "./ClassroomDetailTeacherAddNew.vue?vue&type=script&lang=js"
export * from "./ClassroomDetailTeacherAddNew.vue?vue&type=script&lang=js"
import style0 from "./ClassroomDetailTeacherAddNew.vue?vue&type=style&index=0&id=5fe14034&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe14034",
  null
  
)

export default component.exports